import React, { FC, useCallback } from "react"
import { Title, Text, OnboardingScreenContainer, Button } from "dash-styled"
import { OnboardingProgress } from "../../../../Common/OnboardingProgress/OnboardingProgress"
import { TemplateInstantiateStage } from "../../../../../../../Models/Client/TemplateInstantiation"
import { ReactComponent as PeopleIcon } from "icons/lib/people.svg"
import { ReactComponent as EnvelopeIcon } from "icons/lib/envelope.svg"

interface SelectLabelerStageProps {
    setLabeler: (canoticCrowd: boolean) => void
    onBack: () => void
    onForward: () => void
}

export const SelectLabelerStage: FC<SelectLabelerStageProps> = ({
    setLabeler,
    onBack,
    onForward
}) => {
    const handleCanoticCrowdSelect = useCallback(() => {
        setLabeler(true)
        onForward()
    }, [onForward, setLabeler])

    const handleCollaboratorSelect = useCallback(() => {
        setLabeler(false)
        onForward()
    }, [onForward, setLabeler])

    return (
        <OnboardingScreenContainer celebrate={false} onForward={onForward}>
            <OnboardingProgress
                currentStage={TemplateInstantiateStage.selectLabeler}
                back={false}
                onBack={onBack}
            />
            <div
                id="maincontent"
                className="flex flex-1 flex-col w-full justify-center"
                data-testid="onboarding-select-labeler"
            >
                <Title
                    color="darkviolet"
                    variant="heading1"
                    className="text-center"
                    weight="semibold"
                >
                    Who should process your data?
                </Title>
                <Text
                    component="span"
                    color="gray"
                    className="text-center px-16 mx-4"
                >
                    (You can always change this later, and
                    <br />
                    with either option, we’ll use AI to help)
                </Text>
                <div className="mt-7 flex justify-center mb-32">
                    <Button
                        className="h-59 w-63 rounded-lg mr-4 bg-white"
                        active={true}
                        color="white"
                        key="collaborator"
                        onClick={handleCollaboratorSelect}
                        testId="select-self"
                    >
                        <div className="flex flex-col justify-center items-center">
                            <EnvelopeIcon className="text-rhino-450 w-16 h-16 mb-6" />
                            <Text
                                component="span"
                                className="text-xl text-grape-950 font-semibold"
                            >
                                Me, or people that
                                <br />I invite
                            </Text>
                        </div>
                    </Button>

                    <Button
                        className="h-59 w-63 rounded-lg bg-white"
                        active={true}
                        color="white"
                        key="heroes"
                        onClick={handleCanoticCrowdSelect}
                        testId="select-heroes"
                    >
                        <div className="flex flex-col justify-center items-center">
                            <PeopleIcon className="text-rhino-450 w-18 h-16 mb-5.5" />
                            <Text
                                component="span"
                                className=" text-xl text-grape-950 font-semibold"
                            >
                                super.AI’s human
                                <br />
                                workers
                            </Text>
                        </div>
                    </Button>
                </div>
            </div>
        </OnboardingScreenContainer>
    )
}
